import React from 'react';
import { useStudent } from '../context/StudentContext';
import { Download, FileText, CreditCard } from 'lucide-react';
import './Financials.css';

const Financials = () => {
    const { financials, student, loading } = useStudent();

    if (loading) return null;
    if (!student) return null;

    return (
        <div className="page-container financials-page">
            <header className="page-header">
                <div>
                    <h2 className="page-title">Financials</h2>
                    <p className="page-subtitle">Track your payments and package balance</p>
                </div>
            </header>

            {/* Account Summary */}
            <div className="account-summary-card">
                <div className="summary-item">
                    <span className="label">Total Package Cost</span>
                    <span className="value">${financials.totalamount}</span>
                </div>
                <div className="summary-divider"></div>
                <div className="summary-item">
                    <span className="label">Amount Paid</span>
                    <span className="value text-green">${financials.paidAmount}</span>
                </div>
                <div className="summary-divider"></div>
                <div className="summary-item">
                    <span className="label">Outstanding Balance</span>
                    <span className={`value ${financials.balance > 0 ? 'text-red' : 'text-green'}`}>
                        ${financials.balance}
                    </span>
                </div>
            </div>

            {/* Payment History */}
            <div className="section-title-row">
                <h3>Payment History</h3>
                <button className="btn btn-primary flex items-center gap-2">
                    <CreditCard size={18} /> Make a Payment
                </button>
            </div>

            <div className="card table-card">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Description</th>
                            <th>Method</th>
                            <th>Amount</th>
                            <th>Receipt</th>
                        </tr>
                    </thead>
                    <tbody>
                        {financials.payments.map(payment => (
                            <tr key={payment.id}>
                                <td>{new Date(payment.date).toLocaleDateString()}</td>
                                <td>Tuition Payment</td>
                                <td>{payment.method}</td>
                                <td className="font-bold">${payment.amount}</td>
                                <td>
                                    <button className="btn-link">
                                        <Download size={16} /> Download
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Financials;
